import React from "react";
import "./FeaturePage.css";
import tasks from "../assets/organize.svg";
import { motion } from "framer-motion";

function FeaturePageFour() {
  return (
    <div className="feature-page-wrapper">
      <div className="f-text-wrapper">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.25 }}
          className="f-title"
        >
          Organize your classes all in one spot.
        </motion.p>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="f-sub-txt course-sub-txt"
        >
          Organize all of your courses in one clean, simple and intuitive
          interface.
        </motion.p>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 150 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.6 }}
        className="course-img"
      >
        <img src={tasks} alt="task generation" />
      </motion.div>
    </div>
  );
}

export default FeaturePageFour;
